// DHCP服务器
import React, { createRef, PureComponent } from 'react';
import { Button, notification, Form, InputNumber, Switch } from 'antd';

export class DHCPApplication extends PureComponent {
    constructor(props) {
      super(props);
  
      this.formRef = createRef();
  
      ['onReset', 'onSubmit', 'onFail', 'onChange'].forEach(func => this[func] = this[func].bind(this));
      
      this.state = {
        version: 0,
      }
    }
  
    onReset() {
      this.formRef.current.resetFields();
      this.setState({
        version: 0
      });
    }
  
    async onSubmit(config) {
      const { device } = this.props;
      let { enabled, ipPoolRangeStart, ipPoolRangeEnd } = config;

      device.updateDHCPPool(enabled, ipPoolRangeStart, ipPoolRangeEnd)

      this.setState({
        version: 0
      }, () => {
        notification.success({
            message: '配置已生效',
        });
      });
    }
  
    onFail(errorInfo) {
      notification.error({
        message: '错误',
        description: '表单填写出错，请按照提示信息进行检查！'
      });
    }
  
    onChange(changedValues, allValues) {
      let { version } = this.state;
      version++;
  
      const nextState = {
        version
      };

      this.setState(nextState);
    }
  
    render() {
      const { formRef } = this;
      const { device } = this.props;
      const { enabled, ipPoolRangeStart, ipPoolRangeEnd } = device.toJSON();
      const { version } = this.state;
      const value = { enabled, ipPoolRangeStart, ipPoolRangeEnd };
  
      return (
        <Form
          ref={formRef}
          name="IPConfig"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 10 }}
          initialValues={value}
          size="large"
          onFinish={this.onSubmit}
          onFinishFailed={this.onFail}
          onValuesChange={this.onChange}
        >
            <Form.Item
                label="启用服务"
                name="enabled"
                valuePropName='checked'
            >
                <Switch />
            </Form.Item>
            <Form.Item
                label="起始IP"
                name="ipPoolRangeStart"
                rules={[{ required: true }]}
            >
                <InputNumber min={1} max={255} step={1} precision={0} />
            </Form.Item>
            <Form.Item
                label="终止IP"
                name="ipPoolRangeEnd"
                rules={[{ required: true }]}
            >
                <InputNumber min={1} max={255} step={1} precision={0} />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 4, span: 10 }}>
            <Button type={ version ? "danger": "primary"} htmlType="submit">
              确定
            </Button>
            <Button style={{marginLeft: 10}} htmlType="button" onClick={this.onReset}>
                重置
            </Button>
            </Form.Item>
        </Form>
      );
    }
}
